import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { getToken } from '../../project/helpers/Jwt';
import { dom } from '@fortawesome/fontawesome-svg-core';


const EntryEntity = () => {
    const { id, } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const [loading, setLoading] = useState(false);

    const [projectSelected, setProjectSelected] = useState("");
    const [optionProject, setOptionProject] = useState([]);
    const [loadingProject, setLoadingProject] = useState(false);

    const [domain, setDomain] = useState(""); // Default domain
    const [table, setTable] = useState(""); // Default table name
    const [isIncludeDomain, setIsIncludeDomain] = useState(false);
    const [isTableDropSame, setIsTableDropSame] = useState(true);
    const [sanitizedDomain, setSanitizedDomain] = useState("");

    const [optionInputType, setOptionInputType] = useState([
        { value: 'text', label: 'Text' },
        { value: 'currency_idr', label: 'Mata Uang (Rp)' },
        { value: 'date', label: 'Tanggal' },
        { value: 'time', label: 'Jam' },
        { value: 'option', label: 'Pilihan' },
        { value: 'file', label: 'Berkas' },
        { value: 'image', label: 'Gambar' },
    ]);

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        table: ''
    });

    const [columns, setColumns] = useState([{ id: 1, column: '', columnType: '', inputType: '', label: '' }]);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PROJECT = "api/core/project/project";
    const PATH_ENTITY = "api/system/entity";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {

        setLoadingProject(true);
        fetchData(`${BASE_URL}${PATH_PROJECT}`, {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json"
        }).then((data) => {
            setOptionProject(data);
        }).finally(() => {
            setLoadingProject(false);
        });


    }, []);

    useEffect(() => {

        if (id) {
            setLoading(true);
            fetchData(`${BASE_URL}${PATH_ENTITY}/detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                const { id_project, name, table, table_drop } = detail.data;
                const { columns: fetchedColumns, domain_project: domain } = detail;

                setDomain(domain);
                setTable(table);

                setInitialValues({
                    id_project: id_project || '',
                    name: name || '',
                    table: table || '',
                    table_drop : table_drop || ''
                });

                if (fetchedColumns && fetchedColumns.length > 0) {
                    const mappedColumns = fetchedColumns.map((column, index) => ({
                        id: index + 1,
                        column: column.column || '',
                        columnType: column.column_type || '',
                        inputType: column.input_type || '',
                        label: column.label || '',
                    }));
                    setColumns(mappedColumns);
                }
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);

    useEffect(() => {
        const project = optionProject?.find((project) => project.id == projectSelected);
        setDomain(project?.domain);
    }, [projectSelected]);

    useEffect(() => {
        if (domain) {
            setSanitizedDomain(domain.replace(/\./g, "_"));
        }
    }, [domain, isIncludeDomain, sanitizedDomain]);

    useEffect(() => {
        if (table && sanitizedDomain) {
            if (table.startsWith(sanitizedDomain)) {
                setIsIncludeDomain(true);
            } else {
                setIsIncludeDomain(false);
            }
        }
    }, [sanitizedDomain]);

    const addField = () => {
        const newFields = [...columns];
        newFields.push({ id: newFields.length + 1, column: '', columnType: '', inputType: '', label: '' });
        setColumns(newFields);
    };

    const removeField = (id) => {
        const newFields = columns.filter((column) => column.id !== id);
        setColumns(newFields);
    };

    const handleInputChange = (id, columnKey, value) => {
        const newFields = columns.map((column) =>
            column.id === id ? { ...column, [columnKey]: value } : column
        );
        setColumns(newFields);
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        table: Yup.string().required('Table is required'),
    });

    const onSubmit = async (values, requests) => {
        try {
            const formData = {
                id_project: values.id_project,
                name: values.name,
                table: values.table,
                table_drop: values.table_drop,
                active: 'Y',
                columns: JSON.stringify(columns)
            };

            if (id) {
                formData['id'] = id;
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/system/entity`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`
                    }
                });
            } else {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/system/entity`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`
                    }
                });
            }

            navigate(-1);
        } catch (error) {
            console.error('Error submitting form:', error);
            // Handle error, show alert or set form error state
        } finally {
            requests.setSubmitting(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">Entry Form Entity</h2>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="id_project" className="block text-sm font-medium text-gray-700">
                                Project
                            </label>
                            {loadingProject ? (
                                <h1>Loading...</h1>
                            ) : (
                                <>
                                    <Field
                                        as="select"
                                        name="id_project"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                        onChange={(e) => {
                                            const selectedProjectId = e.target.value;
                                            setProjectSelected(selectedProjectId);
                                            setFieldValue("id_project", selectedProjectId);
                                        }}
                                    >
                                        <option value="" label="Pilih Project" />
                                        {optionProject.map((project) => (
                                            <option key={project.id} value={project.id}>
                                                {project.name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="id_project" component="p" className="text-red-500 text-xs mt-1" />
                                </>
                            )}
                        </div>
                        <div className="gap-4 px-4 py-2">
                            <label htmlFor="name">Name</label>
                            <Field
                                className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                type="text" name="name" />
                            <ErrorMessage name="name" component="p" className='text-red-500 text-xs mt-1' />
                        </div>

                        <div className="gap-4 px-4 py-2 container m-auto grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1">
                            <div className="">
                                <div className='flex justify-between px-4'>
                                    Table
                                    <div className="flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={isIncludeDomain}
                                            onChange={() => {
                                                const currentValue = !isIncludeDomain;
                                                setIsIncludeDomain(currentValue);
                                                const localTable = currentValue ? `${sanitizedDomain}_${values.table}` : values.table.replace(`${sanitizedDomain}_`, "");
                                                setFieldValue("table", localTable);

                                                if (isTableDropSame) {
                                                    setFieldValue("table_drop", localTable)
                                                }
                                            }}
                                            className="mr-2"
                                        />
                                        <label className="text-gray-700">
                                            Join Table with Domain
                                        </label>
                                    </div>
                                </div>
                                <Field
                                    className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    type="text" name="table" />
                                <ErrorMessage name="table" component="p" className='text-red-500 text-xs mt-1' />
                            </div>

                            <div>
                                <div className='flex justify-between px-4'>
                                    Table Drop
                                    <div className="flex items-center">
                                        <input
                                            type="checkbox"
                                            checked={isTableDropSame}
                                            onChange={() => {
                                                const currentValue = !isTableDropSame;
                                                setIsTableDropSame(currentValue);
                                            }}
                                            className="mr-2"
                                        />
                                        <label className="text-gray-700">
                                            Same with Table
                                        </label>
                                    </div>
                                </div>
                                <Field
                                    className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    type="text" name="table_drop" />
                                <ErrorMessage name="table_drop" component="p" className='text-red-500 text-xs mt-1' />
                            </div>

                        </div>

                        <div className='flex justify-between my-2 px-4'>
                            <h1 className='p-2'>Column</h1>
                            <button
                                className="text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 m-1"
                                type="button"
                                onClick={() => addField('request')}>
                                <FontAwesomeIcon icon={faAdd} color="white" />
                            </button>
                        </div>
                        {columns.map((column) => (
                            <div key={column.id} className="flex items-center mb-2 flex-1 px-5">
                                <input
                                    className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    placeholder="Column"
                                    type="text"
                                    name={`column_${column.id}`}
                                    value={column.column}
                                    onChange={(e) => handleInputChange(column.id, 'column', e.target.value)}
                                />
                                <input
                                    className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    placeholder="Column Type"
                                    type="text"
                                    name={`column_type_${column.id}`}
                                    value={column.columnType}
                                    onChange={(e) => handleInputChange(column.id, 'columnType', e.target.value)}
                                />
                                <Field
                                    as="select"
                                    name={`input_type_${column.id}`}
                                    className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    defaultValue={column.inputType}
                                    onChange={(e) => {
                                        setFieldValue(`input_type_${column.id}`, e.target.value); // Update Formik value
                                        handleInputChange(column.id, 'inputType', e.target.value)
                                    }}>
                                    <option value="" label="Input Type" />
                                    {optionInputType.map((inputType) => (
                                        <option key={inputType.value} value={inputType.value}>
                                            {inputType.label}
                                        </option>
                                    ))}
                                </Field>

                                <input
                                    className="m-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    placeholder="Label"
                                    type="text"
                                    name={`label_${column.id}`}
                                    value={column.label}
                                    onChange={(e) => handleInputChange(column.id, 'label', e.target.value)}
                                />

                                <button
                                    className="text-xs rounded focus:ring bg-red-500 hover:bg-red-700 p-2"
                                    onClick={() => removeField(column.id)}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} color="white" />
                                </button>
                            </div>
                        ))}

                        <div className="mt-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                            >
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EntryEntity;
